import { h, createProjector } from 'maquette'

import render from './meta-editor.pug'
import EditorBase from './editor-base'

export default class MetaEditor extends EditorBase
  projector: createProjector()

  constructor: (data)->
    super()

    @data = data

  show: =>
    document.documentElement.classList.add "is-clipped"
    @projector.append(document.body, @_render)

  bindForm: (@form)=>

  _render: =>
    render.call(this)[0]

  dismiss: =>
    await @save()
    location.reload()

  save: =>
    await fetch(
      "/playbooks/#{@data.id}",
      method: "PATCH",
      credentials: 'same-origin',
      headers:
        'X-CSRF-Token': document.head.querySelector("[name='csrf-token']").content
      body: new FormData(@form)
    )
